import type userProfileUseCases from '../../domain/useCases'
import { AlertWindow } from '@sunwebgroup/uds-ui/alert-window'
import { Button } from '@sunwebgroup/uds-ui/button'
import * as React from 'react'
import { useIntl } from 'react-intl'
import { useUserProfileStore } from '../../infrastructure/useUserProfileStore'

interface DeleteAccountProps {
  useCases: ReturnType<typeof userProfileUseCases>
}

export function DeleteAccount({ useCases }: DeleteAccountProps) {
  const intl = useIntl()
  const isDeleteAlertOpen = useUserProfileStore(state => state.isDeleteAlertOpen)
  const setIn = useUserProfileStore(state => state.setIn)

  const handleCloseAlert = () => {
    setIn('isDeleteAlertOpen', false)
  }

  const handleConfirmDelete = async () => {
    await useCases.deleteAccount()
  }

  return (
    <AlertWindow.Root open={isDeleteAlertOpen} onOpenChange={setIn.bind(null, 'isDeleteAlertOpen')}>
      <AlertWindow.Trigger>
        <Button variant="transparentPrimary" size="XS">
          {intl.formatMessage({ id: 'user_profile_delete' })}
        </Button>
      </AlertWindow.Trigger>
      <AlertWindow.Content
        hasIcon
        text={intl.formatMessage({ id: 'user_profile_delete_confirmation_title' })}
        supportingText={intl.formatMessage({ id: 'user_profile_delete_confirmation_description' })}
        renderPrimaryActionSlot={props => (
          <Button {...props} onClick={handleConfirmDelete}>
            {intl.formatMessage({ id: 'user_profile_delete_confirm' })}
          </Button>
        )}
        renderSecondaryActionSlot={props => (
          <Button {...props} onClick={handleCloseAlert}>
            {intl.formatMessage({ id: 'common_cancel_button' })}
          </Button>
        )}
      />
    </AlertWindow.Root>
  )
}
